import { Button, Popover, PopoverContent, PopoverTrigger } from "@tellescope/ui";
import { ChevronDown, Forward, Reply, ReplyAll } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export type EmailReplyMode = "reply" | "reply-all";

export interface EmailReplyModeControlProps {
  replyMode: EmailReplyMode;
  onChangeReplyMode: (mode: EmailReplyMode) => void;
  forwardEmailId?: string;
  disabled?: boolean;
}

export const EmailReplyModeControl = ({
  replyMode,
  onChangeReplyMode,
  forwardEmailId,
  disabled,
}: EmailReplyModeControlProps) => {
  const { t } = useTranslation("inbox");
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="ghost" size="sm" className="h-8 px-2" disabled={disabled}>
          {replyMode === "reply-all" ? <ReplyAll className="h-4 w-4" /> : <Reply className="h-4 w-4" />}
          <ChevronDown className="h-3 w-3 ml-1" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2" align="end">
        <div className="flex flex-col gap-1">
          <Button
            type="button"
            variant={replyMode === "reply" ? "secondary" : "ghost"}
            size="sm"
            className="justify-start"
            onClick={() => {
              onChangeReplyMode("reply");
              setIsPopoverOpen(false);
            }}
          >
            <Reply className="h-4 w-4 mr-2" />
            {t("Reply")}
          </Button>
          <Button
            type="button"
            variant={replyMode === "reply-all" ? "secondary" : "ghost"}
            size="sm"
            className="justify-start"
            onClick={() => {
              onChangeReplyMode("reply-all");
              setIsPopoverOpen(false);
            }}
          >
            <ReplyAll className="h-4 w-4 mr-2" />
            {t("Reply All")}
          </Button>
          {!!forwardEmailId && (
            <Link to={`/messaging/inbox/email/new?forward=true&emailId=${forwardEmailId}`} className="w-full">
              <Button type="button" variant="ghost" size="sm" className="justify-start w-full">
                <Forward className="h-4 w-4 mr-2" />
                {t("Forward")}
              </Button>
            </Link>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
